import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { connect } from 'react-redux';

// Components
import PickUpLocationInfo from './PickUpLocationInfo';

// Selectors
import {
  getDealerContact,
  getDealerName,
  getDealerCountryCode
} from 'store/reducers/dealerSettings/selectors';
import { getLocaleCode } from 'store/reducers/dealerLocale/selectors';
import { getPickupAddress } from 'store/reducers/appointment/valetDetails/selectors';

const mapStateToProps = state => ({
  dealerContact: getDealerContact(state),
  pickUpAddress: getPickupAddress(state),
  dealerName: getDealerName(state),
  locale: getLocaleCode(state),
  dealerCountryCode: getDealerCountryCode(state)
});

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    null
  )
)(PickUpLocationInfo);



// WEBPACK FOOTER //
// ./src/components/atoms/PickUpLocationInfo/PickUpLocationInfoContainer.js